import {z} from 'zod'; // Add new import

export const FormSchema = z.object({
	name: z.string().min(1, {
		error: 'Navn må fylles ut',
	}),
	email: z.email({
		error: 'Må være en gyldig e-postadresse',
	}),
	phone: z.string().optional(),
	businessName: z.string().optional(),
	message: z.string().optional(),
});

export type FormInput = z.infer<typeof FormSchema>;
